export const selectUser = (state) => state.user;
export const selectMarketplaces = (state) => state.marketplaces;
export const selectGroups = (state) => state.groups;
export const selectWarehouses = (state) => state.warehouses;
export const selectAgencies = (state) => state.agencies;
